import React from 'react';
import { Plus, Trash2, Link, CheckCircle } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Button } from '../ui/button';

const Step4CustomLinks = ({ data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  const addLink = () => {
    const newLinks = [
      ...data.customLinks,
      { id: Date.now().toString(), label: '', url: '' }
    ];
    handleChange('customLinks', newLinks);
  };

  const removeLink = (id) => {
    const newLinks = data.customLinks.filter(link => link.id !== id);
    handleChange('customLinks', newLinks);
  };

  const updateLink = (id, field, value) => {
    const newLinks = data.customLinks.map(link =>
      link.id === id ? { ...link, [field]: value } : link
    );
    handleChange('customLinks', newLinks);
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <p className="text-slate-600">Adicione links personalizados como portfólio, blog ou agendamento.</p>
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-medium text-slate-800 flex items-center gap-2">
            <Link className="w-4 h-4 text-blue-500" />
            Links Personalizados
          </h3>
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={addLink}
            className="flex items-center gap-2"
          >
            <Plus className="w-4 h-4" />
            Adicionar Link
          </Button>
        </div>
        
        {data.customLinks.length === 0 ? (
          <div className="text-center py-8 bg-slate-50 rounded-lg border-2 border-dashed border-slate-200">
            <Link className="w-10 h-10 mx-auto text-slate-300 mb-3" />
            <p className="text-slate-500">Nenhum link personalizado adicionado</p>
            <p className="text-sm text-slate-400 mt-1">Clique em &quot;Adicionar Link&quot; para começar</p>
          </div>
        ) : (
          <div className="space-y-4">
            {data.customLinks.map((link, index) => (
              <div
                key={link.id}
                className="p-4 bg-slate-50 rounded-lg border border-slate-200 space-y-3 relative group"
              >
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-slate-600">Link {index + 1}</span>
                  <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    onClick={() => removeLink(link.id)}
                    className="text-red-500 hover:text-red-600 hover:bg-red-50 opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </div>
                
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-600">Rótulo do Link</Label>
                    <Input
                      type="text"
                      placeholder="Ex: Portfólio, Blog, Agendar Reunião"
                      value={link.label}
                      onChange={(e) => updateLink(link.id, 'label', e.target.value)}
                      className="text-sm"
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-600">URL do Link</Label>
                    <Input
                      type="url"
                      placeholder="https://..."
                      value={link.url}
                      onChange={(e) => updateLink(link.id, 'url', e.target.value)}
                      className="text-sm"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      {/* Success Message */}
      <div className="mt-8 p-4 bg-emerald-50 border border-emerald-200 rounded-lg flex items-center gap-3">
        <CheckCircle className="w-6 h-6 text-emerald-500 flex-shrink-0" />
        <div>
          <p className="font-medium text-emerald-800">Tudo pronto!</p>
          <p className="text-sm text-emerald-600">Sua assinatura está pronta para uso.</p>
        </div>
      </div>
    </div>
  );
};

export default Step4CustomLinks;
